import { Fragment } from 'react';

import { createTooltipId } from '../utils';
import BowTieControlMetadata from './BowTieControlMetadata';
import BowTieControlTooltip from './BowTieControlTooltip';

function ControlContent({ control }) {
  return (
    <>
      <span
        className="bow-tie__control-connector bow-tie__control-connector--inner"
        aria-hidden="true"
      />
      <span
        className="bow-tie__control-connector bow-tie__control-connector--outer"
        aria-hidden="true"
      />
      <span className="bow-tie__control-name">{control.nome}</span>
      <BowTieControlMetadata control={control} />
    </>
  );
}

function BowTieControl({
  control,
  side,
  branch,
  branchId,
  index,
  disabled,
  onClick,
}) {
  const canOpen = !disabled && Boolean(control?.riscoPontoControleId);
  const controlId = control?.riscoPontoControleId ?? control?.id;
  const tooltipId = createTooltipId(side, branchId, controlId, index);
  const className = `bow-tie__control bow-tie__control--${side}${
    canOpen ? ' bow-tie__control--interactive' : ''
  }`;
  const card = canOpen ? (
    <button
      id={tooltipId}
      type="button"
      className={className}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={() => onClick(control)}
    >
      <ControlContent control={control} />
    </button>
  ) : (
    <div id={tooltipId} className={className}>
      <ControlContent control={control} />
    </div>
  );

  return (
    <Fragment>
      {card}
      <BowTieControlTooltip
        control={control}
        side={side}
        branch={branch}
        target={tooltipId}
      />
    </Fragment>
  );
}

export default BowTieControl;
